import { VenueLocation } from "@iventis/domain-model/model/venueLocation";
import { IventisRowNode, IventisTimeCellData, TimeCellValue } from "@iventis/data-table";
import { ScheduleConfigEventBlockType } from "@iventis/domain-model/model/scheduleConfigEventBlockType";
import { RecurringEventRule } from "@iventis/domain-model/model/recurringEventRule";
import { RelativeEventRule } from "@iventis/domain-model/model/relativeEventRule";

export interface RunSheetData extends IventisTimeCellData {
    zeroAt?: string;
    estimatedTime?: boolean;
    date: TimeCellValue;
    timeFromZero?: string;
    type: ScheduleConfigEventBlockType;
    venueLocation: VenueLocation;
    shared: string;
    activity: string;
    fa: string;
    recurringEventRules: RecurringEventRule[];
    relativeEventRules: RelativeEventRule[];
    linkedEventId?: string;
    sessionId: string;
    rowColour?: string;
    done?: boolean;
}

export enum InsertRowPosition {
    ABOVE = "ABOVE",
    BELOW = "BELOW",
}

export type RunSheetRowNode = IventisRowNode<RunSheetData>;

export enum RunSheetTemplateEntities {
    Zero = "Zero",
}

export interface EventBlockAndRelatedEventBlock {
    eventBlockId: string;
    relatedToEventBlockId: string;
}
